import axios from 'axios'

export default {
    namespaced: true,
    state: {
        suppliers: [],
        supplierOpcodes: null,
        message: '',
        loading: true
    },
    getters: {
        get_suppliers(state) {
            return state.suppliers;
        },
        get_supplier_opcodes(state) {
            return state.supplierOpcodes;
        },
        get_message(state) {
            return state.message
        },
        get_suppliers_count(state) {
            return state.suppliers.length
        },
        get_loading(state) {
            return Boolean(state.loading)
        }
    },
    mutations: {
        SET_MESSAGE(state, value) {
          state.message = value
        },
        SET_SUPPLIERS(state, value) {
            state.suppliers = value
        },
        SET_SUPPLIER_OPCODES(state, value) {
            state.supplierOpcodes = value
        },
        SET_LOADING(state, value) {
            state.loading = Boolean(value)
        }
    },
    actions: {
        get_suppliers({commit}) {
            commit('SET_LOADING', true)
            return axios.get('api/billing/suppliers')
                .then((res) => {
                    commit('SET_SUPPLIERS', res.data.suppliers)
                    commit('SET_MESSAGE', res.data.msg)
                    commit('SET_LOADING', false)
                })
        },
        get_supplier_opcodes({commit}, payload) {
            commit('SET_LOADING', true)
            return axios.get('api/billing/suppliers')
                .then((res) => {
                    commit('SET_SUPPLIER_OPCODES')
                    commit('SET_LOADING', false)
                })
        }
    },
}
